/**
 * Course email template definitions and utilities.
 */

export const COURSE_EMAIL_VARIABLE_DEFINITIONS = Object.freeze({
  appName: 'Application name shown in sender copy.',
  studentName: 'Student full name.',
  studentEmail: 'Student email address.',
  courseName: 'Course title.',
  courseUrl: 'Direct URL to the course.',
  loginUrl: 'Login URL for the LMS.',
  supportEmail: 'Support mailbox for replies.',
  resetUrl: 'Password reset URL/token link.',
  reminderDays: 'Days since the learner last studied.',
  managerName: 'Course manager or team name.',
});

export const COURSE_EMAIL_TEMPLATE_DEFINITIONS = Object.freeze({
  new_enrollment: {
    label: 'New Enrollment',
    description: 'Sent when a learner is newly enrolled in a course.',
  },
  account_creation: {
    label: 'Account Creation',
    description: 'Sent when a new learner account is created.',
  },
  study_reminder: {
    label: 'Study Reminder',
    description: 'Sent to prompt learners to resume a course.',
  },
  password_reset: {
    label: 'Password Reset',
    description: 'Sent when a learner requests a password reset.',
  },
});

export const COURSE_EMAIL_TEMPLATE_TYPES = Object.freeze(
  Object.keys(COURSE_EMAIL_TEMPLATE_DEFINITIONS)
);

export const COURSE_EMAIL_SAMPLE_VARIABLES = Object.freeze({
  appName: 'Adaptive Learning',
  studentName: 'Jordan Student',
  studentEmail: 'jordan.student@example.com',
  courseName: 'Sample Course',
  courseUrl: 'https://example.com/course/sample-course',
  loginUrl: 'https://example.com/login',
  supportEmail: 'support@example.com',
  resetUrl: 'https://example.com/reset?token=abc123',
  reminderDays: '3',
  managerName: 'Learning Team',
});

export function extractTemplateVariables(template = '') {
  const text = String(template || '');
  const regex = /{{\s*([a-zA-Z0-9_]+)\s*}}/g;
  const found = new Set();

  let match = regex.exec(text);
  while (match) {
    found.add(match[1]);
    match = regex.exec(text);
  }

  return Array.from(found);
}

export function renderEmailTemplate(template = '', variables = {}) {
  const text = String(template || '');
  const regex = /{{\s*([a-zA-Z0-9_]+)\s*}}/g;

  return text.replace(regex, (fullMatch, variableName) => {
    if (!Object.prototype.hasOwnProperty.call(variables, variableName)) {
      return fullMatch;
    }

    const value = variables[variableName];
    if (value === null || value === undefined) {
      return '';
    }

    return String(value);
  });
}
